import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { Location } from '@freelancer/location';
import { VerticalAlignment } from '@freelancer/ui/grid';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { ViewHeaderBackground, ViewHeaderType } from './view-header.types';

@Component({
  selector: 'fl-view-header',
  template: `
    <fl-bit
      class="ViewHeaderContent"
      [attr.data-background]="background"
      [attr.data-side-notch]="sideNotch"
    >
      <fl-bit class="ViewHeaderContent-inner">
        <fl-button
          *ngIf="showBackButton"
          class="ViewHeaderContent-action"
          [flShowMobile]="true"
          (click)="handleIconClick()"
        >
          <fl-icon
            *ngIf="type === 'back'"
            i18n-title="Header back button"
            title="Back"
            [size]="IconSize.SMALL"
            [name]="'ui-chevron-left'"
            [color]="IconColor.INHERIT"
          ></fl-icon>
          <fl-icon
            *ngIf="type !== 'back'"
            i18n-title="Header close button"
            title="Close"
            [size]="IconSize.SMALL"
            [name]="'ui-close'"
            [color]="IconColor.INHERIT"
          ></fl-icon>
        </fl-button>

        <fl-bit
          class="ViewHeaderContent-title"
          [ngClass]="{ 'ViewHeaderContent-title--indented': showBackButton }"
        >
          <ng-content></ng-content>
        </fl-bit>

        <fl-button
          *ngIf="showMenu"
          class="ViewHeaderContent-action"
          (click)="menuClick.emit()"
        >
          <fl-icon
            i18n-title="Header menu button"
            title="Menu"
            [name]="'ui-show-more'"
            [size]="IconSize.SMALL"
            [color]="IconColor.INHERIT"
          ></fl-icon>
        </fl-button>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./view-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewHeaderComponent {
  IconSize = IconSize;
  IconColor = IconColor;
  VerticalAlignment = VerticalAlignment;

  @Input() type = ViewHeaderType.BACK;
  @Input() showBackButton = true;
  @Input() showMenu = false;
  @Input() sideNotch = true;

  @HostBinding('attr.data-background')
  @Input()
  background = ViewHeaderBackground.LIGHT;

  @Output() menuClick = new EventEmitter();
  @Output() close = new EventEmitter();

  constructor(private location: Location) {}

  handleIconClick(): void {
    if (this.type === ViewHeaderType.BACK) {
      // TODO: T267853 - handle route changes under one heading (eg. pvp tabs)
      this.location.back();
    } else {
      this.close.emit();
    }
  }
}
